import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
  getKnownHiringTemplateDisplayName,
  resolveHiringTemplateDisplayName,
} from 'lib/hiringTemplateUtils'

export function useLocalizedHiringTemplateName(name: string | null | undefined): string | null {
  const { i18n } = useTranslation()
  const [displayName, setDisplayName] = useState<string | null>(() =>
    getKnownHiringTemplateDisplayName(name, i18n.language) ?? name ?? null
  )

  useEffect(() => {
    if (!name?.trim()) {
      setDisplayName(null)
      return
    }

    let cancelled = false

    const resolveName = async () => {
      const known = getKnownHiringTemplateDisplayName(name, i18n.language)
      if (known) {
        setDisplayName(known)
        return
      }

      if (i18n.language.startsWith('en')) {
        setDisplayName(name)
        const translated = await resolveHiringTemplateDisplayName(name, i18n.language)
        if (!cancelled) {
          setDisplayName(translated)
        }
        return
      }

      setDisplayName(name)
    }

    void resolveName()

    return () => {
      cancelled = true
    }
  }, [name, i18n.language])

  return displayName
}
